import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  ProductModifierFirestoreResponse,
  CreateProductModifierDto,
  UpdateProductModifierDto,
  DeleteProductModifierResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const ProductModifierResponseSchema = ProductModifierFirestoreResponse;
export const CreateProductModifierSchema = CreateProductModifierDto;
export const UpdateProductModifierSchema = UpdateProductModifierDto;

// ====== Type Exports ======
export type ProductModifierResponse = z.infer<typeof ProductModifierFirestoreResponse>;
export type CreateProductModifier = z.infer<typeof CreateProductModifierDto>;
export type UpdateProductModifier = z.infer<typeof UpdateProductModifierDto>;

// API factory function
export function createProductModifiersApi(client: TypedApiClient) {
  return {
    getProductModifiers: (): Promise<ProductModifierResponse[]> => {
      return client.get('/product-modifiers', {
        responseSchema: z.array(ProductModifierFirestoreResponse),
      });
    },

    getProductModifierById: (id: string): Promise<ProductModifierResponse> => {
      return client.get(apiPath`/product-modifiers/${id}`, {
        responseSchema: ProductModifierFirestoreResponse,
      });
    },

    createProductModifier: (data: CreateProductModifier): Promise<ProductModifierResponse> => {
      return client.post('/product-modifiers', {
        data,
        requestSchema: CreateProductModifierDto,
        responseSchema: ProductModifierFirestoreResponse,
      });
    },

    updateProductModifier: (id: string, data: UpdateProductModifier): Promise<ProductModifierResponse> => {
      return client.patch(apiPath`/product-modifiers/${id}`, {
        data,
        requestSchema: UpdateProductModifierDto,
        responseSchema: ProductModifierFirestoreResponse,
      });
    },

    deleteProductModifier: (id: string): Promise<z.infer<typeof DeleteProductModifierResponseDto>> => {
      return client.delete(apiPath`/product-modifiers/${id}`, {
        responseSchema: DeleteProductModifierResponseDto,
      });
    },
  };
}
